export const isGeneralCourse = (title) => String(title || "").trim().toLowerCase().startsWith("formazione generale dei lavoratori");
export const isSpecificCourse = (c) => c?.modality === "elearning"
  && String(c?.title || "").trim().toLowerCase().startsWith("formazione specifica lavoratori -");
